import { defineStore } from 'pinia'
import axios from '@/axios'
import authService from './authService'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token') || '',
    user: null
  }),
  getters: {
    isAuthenticated: (state) => !!state.token
  },
  actions: {
    async login(email, password) {
      try {
        // Breakpoint aqui: inspecione email e password
        const res = await axios.post('/auth/login', { email, password })
        
        // Breakpoint aqui: inspecione a resposta da API
        this.token = res.data.access_token
        this.user = res.data.user
        localStorage.setItem('token', this.token)
        return true
      } catch (e) {
        // Breakpoint aqui: debugar erros de login
        console.error('Erro no login:', e)
        return false
      }
    },
    async verificarSessao() {
      this.token = localStorage.getItem('token') || ''
      return await authService.verificarStatusSessao()
    },
    logout() {
      this.token = ''
      this.user = null
      localStorage.removeItem('token')
    }
  }
})